import { yupResolver } from "@hookform/resolvers/yup";
import { Stack } from "@mui/material";
import { type FC, useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import * as yup from "yup";
import { useTypedTranslation } from "../../hooks";
import { DatePicker } from "../Form";
import * as Styled from "./TransactionsTab.styled";
import { PremiumScheduleFilter } from "./TransactionsTabPremiumSchedule";

export const TransactionsTabPremiumScheduleFilterModal: FC<{
    setReturnPayload: React.Dispatch<React.SetStateAction<object | undefined>>;
    resolve?: () => void;
    initialValues: PremiumScheduleFilter;
}> = ({ setReturnPayload, initialValues }) => {
    const { t } = useTypedTranslation();

    const validationSchema = yup
        .object<PremiumScheduleFilter>()
        .shape({
            from: yup.date().typeError(t("errorMessages.invalidDateFormat")).nullable().defined(),
            to: yup.date().typeError(t("errorMessages.invalidDateFormat")).nullable().defined(),
        })
        .test("date-range", t("errorMessages.toDateLaterThanFromDate"), function (values, ctx) {
            const { from, to } = values || {};
            if (from && to && from > to) {
                return ctx.createError({
                    path: "from",
                    message: t("errorMessages.toDateLaterThanFromDate"),
                });
            }
            return true;
        });

    const methods = useForm<PremiumScheduleFilter>({
        defaultValues: {
            from: initialValues.from,
            to: initialValues.to,
        },
        mode: "onChange",
        resolver: yupResolver(validationSchema),
    });
    const { watch, trigger } = methods;

    const userDefinedFilter = watch();

    useEffect(() => {
        // Revalidate both fields so cross-field errors clear correctly
        void trigger(["from", "to"]);
        setReturnPayload(userDefinedFilter);
    }, [trigger, setReturnPayload, userDefinedFilter]);

    return (
        <FormProvider {...methods}>
            <form>
                <Stack>
                    <Styled.FilterFormLabel htmlFor="from">
                        {t("fufi.regulationsFilters.periodPremiums")}
                    </Styled.FilterFormLabel>
                    <Stack sx={{ gap: 5, flexDirection: { xs: "column", sm: "row" } }}>
                        <DatePicker name="from" placeholder={t("fufi.regulationsFilters.dateFrom")} />
                        <DatePicker name="to" placeholder={t("fufi.regulationsFilters.dateTo")} />
                    </Stack>
                </Stack>
            </form>
        </FormProvider>
    );
};
